import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM3.72326 7.48035C3.36232 7.3374 2.95384 7.51412 2.81089 7.87506C2.66795 8.236 2.84467 8.64449 3.20561 8.78743L3.8924 9.05943C5.24631 9.59563 6.75369 9.59563 8.1076 9.05943L8.79439 8.78743C9.15533 8.64449 9.33205 8.236 9.18911 7.87506C9.04616 7.51412 8.63768 7.3374 8.27674 7.48035L7.58995 7.75235C6.56857 8.15685 5.43143 8.15685 4.41005 7.75235L3.72326 7.48035Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }